import ACTIONS from "./types";
import axios from "axios";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";
import { Ability } from "@casl/ability";

export const FetchAllOrganizationsList = () => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.ORGANIZATIONS}`)
    .then((res) => {
      if (res.data.length === 0) return;
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS,
        payload: [...res.data],
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_FAILURE,
        payload: err,
      });
    });
};

export const setAllOrganizationsList = (organizations) => (dispatch) => {
  dispatch({
    type: ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS,
    payload: [...organizations],
  });
};

export const getOrgUserAbility = (orgId) => (dispatch) => {
  dispatch({
    type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_START,
  });
  return axios
    .get(`${API_ENDPOINTS.ORGANIZATIONS.replace("org_id", orgId)}/abilities`)
    .then((res) => {
      const ability = new Ability(res.data);

      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_SUCCESS,
        payload: res.data,
      });
      return ability;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const getOrganizationInfo = (orgId) => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.ORGANIZATIONS}/${orgId}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_INFO,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_INFO_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const getOrganizationDevicesList = (orgId, int_clientIntegratedDevices) => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.ORGANIZATIONS}/${orgId}/devices`)
    .then((res) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_DEVICES_LIST,
        payload: res.data,
      });

      // dispatch({
      //   type: ACTIONS.INTEGRATION.SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES,
      //   payload: differenceBy(int_clientIntegratedDevices, res.data, "_id")
      // });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_DEVICES_LIST_FAILURE,
        payload: err,
      });
    });
};
